<template>
  <b-tabs
    nav-class="nav-left"
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    nav-wrapper-class="col-md-3 col-12"
    pills
    vertical
  >
    <b-tab>
      <template #title>
        <span class="font-weight-bold">
          <feather-icon icon="UsersIcon" />
          {{ $t('Manage Users') }}
        </span>
      </template>

      <b-card>
        <manage-users
          :teams="teams"
          :current-team="teamDetails || $route.params.team"
          @updated="() => fetchTeamDetails()"
        />
      </b-card>
    </b-tab>

    <b-tab>
      <template #title>
        <span class="font-weight-bold">
          <feather-icon icon="ClockIcon" />
          {{ $t('Time Limit Settings') }}
        </span>
      </template>

      <b-card>
        <time-limit-setting
          :teams="teams"
          :current-team="teamDetails || $route.params.team"
          @updated="() => fetchTeamDetails()"
        />
      </b-card>
    </b-tab>
  </b-tabs>
</template>
<script>
import { BCard, BTabs, BTab } from 'bootstrap-vue'
import useApollo from '@/plugins/graphql/useApollo'
import TimeLimitSetting from './TimeLimitSetting.vue'
import ManageUsers from './ManageUsers.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    TimeLimitSetting,
    ManageUsers,
  },
  data() {
    return {
      teams: [],
      teamDetails: null,
      selectedProject: this.$store.state.project.selectedProject,
    }
  },

  computed: {
    uuid() {
      return this.$route.params.team.uuid
    },
  },
  mounted() {
    this.fetchTeamDetails()
  },

  methods: {
    fetchTeamDetails() {
      useApollo.team.getTeamDetails({ projectUid: this.selectedProject, teamUid: this.uuid }).then(res => {
        const team = res.data.project?.teams?.data[0]
        this.teamDetails = team || null

        const teamMembers = team?.users?.data || []
        this.teams = teamMembers.map(member => ({
          name: member.name,
          uid: member.uuid,
          avatar: member.avatar,
          isOnline: member.isOnline,
          tags: member.tags,
          hours: member?.projectSettings?.data[0]?.information?.hours,
          limitType: member?.projectSettings?.data[0]?.information?.type,
        }))
      })
    },
  },
}
</script>
